import { createClient } from "@supabase/supabase-js";

// CRA build/runtime in this repo is standardized on REACT_APP_* keys.
// Keep NEXT_PUBLIC_* only as a legacy fallback for mixed deployments.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (
	process.env.REACT_APP_SUPABASE_URL &&
	process.env.NEXT_PUBLIC_SUPABASE_URL &&
	process.env.REACT_APP_SUPABASE_URL !== process.env.NEXT_PUBLIC_SUPABASE_URL
) {
	console.warn("REACT_APP_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_URL differ. Using REACT_APP_SUPABASE_URL.");
}

const isPlaceholderUrl = typeof supabaseUrl === "string" && supabaseUrl.includes("your-project.supabase.co");
const isPlaceholderKey = typeof supabaseAnonKey === "string" && supabaseAnonKey.includes("your-anonymous-key");

if (!supabaseUrl || !supabaseAnonKey || isPlaceholderUrl || isPlaceholderKey) {
	throw new Error(
		"Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env with real values from Supabase Dashboard > Settings > API, then restart npm start."
	);
}

// Get active tenant ID from localStorage for tenant context
const getActiveTenantId = () => {
	try {
		const tenantId = localStorage.getItem('activeTenantId');
		// Validate that the tenant ID is a valid UUID to prevent URL strings from being passed
		if (tenantId && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(tenantId)) {
			return tenantId;
		}
		return null;
	} catch (e) {
		return null;
	}
};

const tenantAwareFetch = (input, init = {}) => {
	const headers = new Headers(init.headers || {});
	const tenantId = getActiveTenantId();

	if (tenantId) {
		headers.set('X-Tenant-ID', tenantId);
	} else {
		headers.delete('X-Tenant-ID');
	}

	return fetch(input, {
		...init,
		headers,
	});
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	global: {
		fetch: tenantAwareFetch,
	}
});

// Function to update tenant context in Supabase client headers
export const updateTenantContext = (tenantId) => {
	if (tenantId) {
		localStorage.setItem('activeTenantId', tenantId);
	} else {
		localStorage.removeItem('activeTenantId');
	}
};

export default supabase;

